import isMobileVersion from 'store/mobile'

export const horizontalPagePadding = isMobileVersion ? 0 : 25
export const verticalPagePadding = 35
